import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';
export let EFaxFormFieldNames;
(function (EFaxFormFieldNames) {
  EFaxFormFieldNames["PatientFirstName"] = "firstName";
  EFaxFormFieldNames["PatientLastName"] = "lastName";
  EFaxFormFieldNames["PatientDateOfBirth"] = "dateOfBirth";
  EFaxFormFieldNames["PatientPhoneNumber"] = "phoneNumber";
  EFaxFormFieldNames["FaxCoverPages"] = "coverPages";
  EFaxFormFieldNames["FaxType"] = "category";
  EFaxFormFieldNames["FaxSubtype"] = "subCategory";
  EFaxFormFieldNames["FaxDateReceived"] = "receivedAt";
  EFaxFormFieldNames["FaxProviderName"] = "providerName";
  EFaxFormFieldNames["FaxFacilityName"] = "facilityName";
  EFaxFormFieldNames["FaxMedicationName"] = "medicationName";
  EFaxFormFieldNames["FaxTestName"] = "labName";
  EFaxFormFieldNames["FaxAuthorizationStatus"] = "authorizationStatus";
  EFaxFormFieldNames["FaxTestType"] = "testType";
  EFaxFormFieldNames["FaxReferringProvider"] = "referringProvider";
  EFaxFormFieldNames["FaxReferringPractice"] = "referringPractice";
  EFaxFormFieldNames["FaxFileName"] = "fileName";
  EFaxFormFieldNames["FaxEhrFileReviewStatus"] = "ehrFileReviewStatus";
  EFaxFormFieldNames["FaxEhrAssignee"] = "ehrAssignee";
})(EFaxFormFieldNames || (EFaxFormFieldNames = {}));
export const fieldsFaxDocumentCategory = _extends({}, fieldsIBaseModelWithUser, {
  template: {
    type: 'ID',
    ref: EModel.FaxDocumentCategory
  },
  name: {
    type: 'Text'
  },
  code: {
    type: 'Text'
  },
  enabled: {
    type: 'Boolean'
  },
  dateParsingRule: {
    type: 'Object'
  },
  description: {
    type: 'Text'
  },
  fieldsToExtract: {
    type: 'Option',
    values: EFaxFormFieldNames,
    array: true
  },
  type: {
    type: 'Text'
  }
});